// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3Tce6","author":"Table_author__1Zszc","authorImage":"Table_authorImage__4y8by","unreadRow":"Table_unreadRow__qbxFP"};